<template>
    <form  @submit="onSubmit" method="POST" ref="form" id="sendy-form2">
            <input type="email"  name="email" placeholder="Enter email address" id="email"/>
            <input type="hidden" name="list" value="y3Ep0BGWhxkmrB1763I53pMQ"/>
            <input type="hidden" name="api_key" value="Z0skjz8tyn5VcME6DCmr"/>
            <div id="hp">
						<label for="hp">HP</label>
						<input type="text" name="hp" id="hp">
					</div>
            <div class="sendySubmit">
                <input type="image" alt="dwerve-subscribe" class="animated pulse animated-infinite bounce_button" src="/static/assets/images/Subscribe.png" name="submit" id="submit"/>
            </div>
        </form>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
        email: '',
        description: '',
        output: ''
    };
  },
 methods: {
     ...mapActions(['steamConfirmFromModal']),
     onSubmit(e) {
     
        e.preventDefault();
        function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form2').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
           if(data.includes("You're already subscribed!"))
		    {
                self.steamConfirmFromModal();
            }
            else if (data.includes("You're subscribed!"))
		    {
                self.steamConfirmFromModal();
            }
            else if (data.includes("Thank you, a confirmation email has been sent to you."))
		    {
               self.steamConfirmFromModal();
            }
            else if (data.includes("A confirmation email had already been sent to you."))
		    {
                
                self.onNotConfrimed(e);
            }
            else {
                console.log(data);
                 
           }
        }
        
    });    
    },
    onNotConfrimed(e){
       e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/unsubscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
               self.onReSubmit(e);
            
                 
        }
        
    });
    },
     onReSubmit(e){
       e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
            self.steamConfirmFromModal();
        }
        
    });
    }
 },
};
</script>

<style>
.text-scroll-inner {
    width: 100%;
    margin: 0 auto;
    text-align: center;
}
.sendyModal input#email {
    width: 100%;
    height: 40px;
    position: relative;
    top: 6px;
    font-size: 12px;
    padding: 10px;
    color: #a2a2a2;
    border: 1px solid #555;
    border-radius: 3px;
}
.sendySubmit{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendySubmit input#submit {
    width: 127px;
    height: 50px;
}
p.g-recaptcha iframe {
    width: 100%;
    margin-top: 10px;
}
p.g-recaptcha div {
    width: 100% !important;
    height: auto !important;
}

p.g-recaptcha {
    margin-bottom: 0;
    width: 100%;
    margin-top: 10px;
}
.sendyWrap form {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.sendyModal label {
    width: 100%;
    font-family: Grandmaster;
    font-size: 13px;
    color: #595959;
    text-shadow: none;
    text-align: left;
    text-transform: none;
    font-weight: 100;
    margin-bottom: 0px;
    position: absolute;
}
#hp{
    display: none;
}
.sendySubmit {
    margin-top: 29px;
}
.swal2-container {
    z-index: 9999999;
}
</style>


// WEBPACK FOOTER //
// src/views/Home/Sendy.vue